module.exports = __webpack_public_path__ + "static/img/5.8c08e5e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/5/sp/5.png
// module id = A8XF
// module chunks = 0